import { useMemo } from 'react';
import { useUserPermissions } from 'entities/user';

export const useServicesVisibility = () => {
  const permissions = useUserPermissions();

  return useMemo(() => ({
    buildingRouteFilter: !!permissions.buildingRouteServiceSelect,
    stationsFilter: !!permissions.servicePointFilterServiceSelect
  }), [permissions]);
};
